import React from 'react'
import css from './style.scss'
import Story from './story'
import {connect} from 'react-redux'
import cn from 'classnames'
import moment from 'moment'
import store from 'utils/store'

import { n } from 'shared/numbers'

const StoriesList=(props)=>{
  const dailyImpressions=props.stories.reduce((acc, story)=> acc = acc + (story.insights.impressions===-1 ? 0 : story.insights.impressions), 0)
  const onClickDownload=()=>{
    if(props.user){
      if(props.active_subscription){
        store.dispatch({type:"EXPORT_STORIES", payload:{filename: "download", stories:props.stories}})
      }else{
        store.dispatch({type:"OPEN_PREMIUM_MODAL"})
      }
    }
  }
  return(
      <div className={css.day_story}>
        {!props.onlyStories &&
          <div>
            {props.day && <h4>{moment(props.day).format("D MMMM")}</h4>}
            {props.miniStats &&
              <div className={cn(css.day_story_options) }>
                <b>{n(dailyImpressions)}</b>  total impressions {props.user &&
                  <span className={css.downloadLink}> - <a onClick={onClickDownload}>Download</a></span>
                }
              </div>
            }
          </div>
        }
        <div className={cn(css.storiesContainer, props.onlyStories ? css.onlyStories : "")}>
          {props.stories.map(story=>
            <Story
              baseName={props.baseName}
              onSelect={props.onSelect}
              selected={props.selectedStories ? props.selectedStories.find(s=>s.id===story.id) : false}
              fullDate={props.withFullDate}
              selectIcon={props.selectIcon}
              select={props.select}
              key={story.id}
              {...story}
              />)
            }
        </div>
      </div>
  )
}

const mapStateToProps=(state)=>{
  return {
    user:state.user.authenticated,
    active_subscription:state.user.authenticated && state.user.userData.subscription.active
  }
}

export default connect(mapStateToProps)(StoriesList)



// WEBPACK FOOTER //
// ./src/components/account_page/stories/list/index.js